import { useEffect, useState } from 'react';

import { getStyled } from './styles';

import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Chip,
  useTheme,
} from '@mui/material';

import toastError from '../../toasts/toastError';
import api from '../../services/api';
import { i18n } from '../../translate/i18n';

const QueueSelect = ({ selectedQueueIds, onChange }) => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const [queues, setQueues] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/queue');
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  });

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div style={{ marginTop: 6 }}>
      <FormControl fullWidth margin='dense' variant='outlined'>
        <InputLabel sx={theme.custom.label}>
          {i18n.t('queueSelect.inputLabel')}
        </InputLabel>
        <Select
          sx={theme.custom.selectField}
          multiple
          labelWidth={60}
          label={i18n.t('queueSelect.inputLabel')}
          value={selectedQueueIds}
          onChange={handleChange}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getcontentanchorel: null,
            PaperProps: {
              sx: {
                backgroundColor: theme.custom.colors.defaultBackground,
                color: theme.custom.colors.text,
              },
            },
          }}
          renderValue={(selected) => (
            <div style={classes.chips}>
              {selected?.length > 0 &&
                selected.map((id) => {
                  const queue = queues.find((q) => q.id === id);
                  return queue ? (
                    <Chip
                      key={id}
                      variant='outlined'
                      label={queue.name}
                      sx={classes.chip && { backgroundColor: queue.color }}
                    />
                  ) : null;
                })}
            </div>
          )}
        >
          {queues.map((queue) => (
            <MenuItem key={queue.id} value={queue.id}>
              {queue.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default QueueSelect;
